import type { MessageKey } from "./en";

export const viMessages: Record<MessageKey, string> = {
  "lang.en": "Tiếng Anh",
  "lang.vi": "Tiếng Việt",
  "nav.contact": "Liên hệ",
  "nav.home": "Trang chủ",
  "nav.support": "Hỗ trợ kỹ thuật",
  "nav.openMenu": "Mở menu",
  "nav.closeMenu": "Đóng menu",
  "breadcrumb.home": "Trang chủ",
  "breadcrumb.news": "Tin tức",
  "news.title": "Tin tức",
  "news.description": "Tin tức sản phẩm, cập nhật công nghệ và thông tin triển khai hệ thống camera, nền tảng quản lý video của VIVOO.",
  "news.metaTitle": "Tin tức",
  "news.metaDescription": "Cập nhật sản phẩm VIVOO, công nghệ camera AI và các ứng dụng quản lý video trong vận hành doanh nghiệp.",
  "news.empty": "Chưa có bài viết tin tức nào.",
  "news.noContent": "Không có nội dung chi tiết cho bài viết này.",
  "news.readMore": "Đọc thêm",
  "news.viewAll": "Xem tất cả tin tức",
  "news.ctaTitle": "Cần tư vấn cho hệ thống của bạn?",
  "news.ctaDescription": "Gửi yêu cầu về model thiết bị, tích hợp hoặc triển khai để đội ngũ VIVOO trao đổi phương án phù hợp.",
  "news.ctaButton": "Liên hệ",
  "catalog.compareProducts": "SO SÁNH SẢN PHẨM",
  "hero.getPricing": "NHẬN BÁO GIÁ",
  "product.learnMore": "Xem sản phẩm",
  "product.viewAll": "Xem tất cả sản phẩm",
  "solutions.viewAll": "Xem tất cả giải pháp",
  "contact.title": "Trao đổi về cấu hình và triển khai hệ thống",
  "contact.description": "Chia sẻ yêu cầu về camera AI, nền tảng quản lý video hoặc tích hợp hệ thống. VIVOO sẽ cùng bạn xác định cấu hình và phạm vi triển khai.",
  "contact.pageTitle": "Liên hệ VIVOO",
  "contact.ctaDetails": "Gửi thông tin về địa điểm, số lượng camera, hiện trạng hạ tầng mạng và mục tiêu giám sát để đội ngũ VIVOO chuẩn bị nội dung trao đổi.",
  "contact.pageDescription": "Chia sẻ quy mô hệ thống, hiện trạng thiết bị và yêu cầu kỹ thuật. Đội ngũ VIVOO sẽ đề xuất cấu hình và phương án triển khai phù hợp.",
  "contact.firstName": "Tên*",
  "contact.lastName": "Họ*",
  "contact.workEmail": "Email công việc*",
  "contact.phoneNumber": "Số điện thoại*",
  "contact.companyName": "Tên công ty*",
  "contact.postalCode": "Mã bưu điện*",
  "contact.optionalMessage": "Tùy chọn: Mô tả địa điểm, quy mô hệ thống hoặc yêu cầu kỹ thuật",
  "contact.submit": "GỬI",
  "contact.sending": "Đang gửi...",
  "contact.requiredField": "Vui lòng hoàn thành trường bắt buộc này.",
  "contact.thankYou": "Cảm ơn bạn!",
  "contact.successMessage": "Thông tin của bạn đã được gửi thành công. Chúng tôi sẽ liên hệ lại trong thời gian sớm nhất.",
  "contact.backHome": "Về trang chủ",
  "support.metaTitle": "Hỗ trợ kỹ thuật VIVOO",
  "support.metaDescription": "Hướng dẫn cấu hình camera, xử lý sự cố, kiểm tra bảo hành và triển khai hệ thống VIVOO.",
  "support.eyebrow": "Hỗ trợ kỹ thuật VIVOO",
  "support.title": "Hướng dẫn cấu hình, xử lý sự cố và bảo trì thiết bị",
  "support.description": "Chọn nội dung cần hỗ trợ: kết nối camera, chất lượng hình ảnh, ghi hình, cảnh báo, ứng dụng, bảo hành hoặc triển khai dự án. Cung cấp model và mô tả lỗi để rút ngắn thời gian kiểm tra.",
  "support.requestSupport": "Yêu cầu hỗ trợ",
  "support.callNow": "Gọi ngay",
  "support.phone": "Điện thoại",
  "support.email": "Email",
  "support.hours": "Thời gian làm việc",
  "support.address": "Địa chỉ",
  "support.topicTitle": "Chọn nội dung hỗ trợ",
  "support.topicDescription": "Chọn nhóm vấn đề bên dưới để xem đúng kênh xử lý, từ cấu hình và kết nối thiết bị đến bảo hành và triển khai tại chỗ.",
  "support.topic.technical.title": "Xử lý sự cố kỹ thuật",
  "support.topic.technical.description": "Hỗ trợ kết nối camera, chất lượng hình ảnh, ghi hình, cảnh báo, cấu hình mạng và kiểm tra tình trạng hệ thống.",
  "support.topic.warranty.title": "Bảo hành và dịch vụ",
  "support.topic.warranty.description": "Hướng dẫn kiểm tra bảo hành, yêu cầu thay thế, kế hoạch bảo trì và tài liệu dịch vụ.",
  "support.topic.documents.title": "Tài liệu và hướng dẫn",
  "support.topic.documents.description": "Yêu cầu datasheet, hướng dẫn lắp đặt, ghi chú cấu hình, tài liệu firmware và hồ sơ bàn giao dự án.",
  "support.topic.app.title": "Ứng dụng và tài khoản",
  "support.topic.app.description": "Hỗ trợ truy cập ứng dụng di động, phân quyền người dùng, khôi phục mật khẩu, cài đặt thông báo và xem từ xa.",
  "support.topic.project.title": "Hỗ trợ triển khai",
  "support.topic.project.description": "Hỗ trợ khảo sát, chọn thiết bị, điều phối lắp đặt, nghiệm thu và đào tạo vận hành.",
  "support.topic.remote.title": "Hỗ trợ từ xa",
  "support.topic.remote.description": "Chia sẻ thông tin sự cố để đội ngũ của chúng tôi kiểm tra log, cấu hình và triệu chứng nhằm đề xuất hướng xử lý nhanh nhất.",
  "support.processTitle": "Quy trình hỗ trợ",
  "support.processDescription": "Kèm tên địa điểm, model và số serial, phiên bản firmware nếu có, thời điểm xảy ra lỗi cùng ảnh hoặc ảnh chụp màn hình liên quan.",
  "support.step.1": "Gửi yêu cầu qua form liên hệ, điện thoại hoặc email kèm thông tin cơ bản về địa điểm và thiết bị.",
  "support.step.2": "Đội ngũ của chúng tôi xác nhận sự cố, kiểm tra phạm vi bảo hành hoặc dịch vụ và ưu tiên xử lý yêu cầu.",
  "support.step.3": "Chúng tôi hướng dẫn từ xa trước, sau đó lên lịch kiểm tra tại chỗ khi cần đánh giá trực tiếp thiết bị.",
  "support.step.4": "Sau khi xử lý, chúng tôi tóm tắt hành động đã thực hiện và khuyến nghị kiểm tra phòng ngừa nếu cần.",
  "support.faqTitle": "Câu hỏi thường gặp",
  "support.faqDescription": "Thông tin cần chuẩn bị và các bước xử lý thường gặp khi cấu hình hoặc vận hành thiết bị VIVOO.",
  "support.faq.q1.question": "Tôi cần chuẩn bị thông tin gì trước khi yêu cầu hỗ trợ?",
  "support.faq.q1.answer": "Vui lòng chuẩn bị tên công ty hoặc địa điểm, người liên hệ, số điện thoại, model sản phẩm, mô tả sự cố và hình ảnh hoặc ảnh chụp màn hình liên quan.",
  "support.faq.q2.question": "Vivoo có hỗ trợ xử lý sự cố từ xa không?",
  "support.faq.q2.answer": "Có. Với nhiều vấn đề phần mềm, cấu hình và kết nối, đội ngũ của chúng tôi có thể hướng dẫn từ xa trước khi lên lịch kiểm tra tại chỗ.",
  "support.faq.q3.question": "Tôi yêu cầu hỗ trợ bảo hành như thế nào?",
  "support.faq.q3.answer": "Hãy gửi model sản phẩm, số serial nếu có, thông tin mua hàng hoặc dự án và mô tả ngắn về sự cố để chúng tôi kiểm tra phạm vi bảo hành.",
  "support.faq.q4.question": "Vivoo có hỗ trợ lắp đặt và đào tạo không?",
  "support.faq.q4.answer": "Có. Chúng tôi có thể điều phối hỗ trợ triển khai, nghiệm thu và đào tạo vận hành cơ bản tùy theo phạm vi dự án.",
  "footer.products": "Sản phẩm",
  "footer.solutionsAndServices": "Giải pháp & Dịch vụ",
  "footer.contactUs": "Liên hệ",
  "resources.title": "Tài nguyên",
  "resources.description": "Tải công cụ cấu hình camera, tài liệu lắp đặt, datasheet và firmware phục vụ triển khai, bảo trì thiết bị VIVOO.",
  "resources.cameraConfig.title": "Công cụ cấu hình camera",
  "resources.cameraConfig.description": "Cấu hình camera, áp dụng cài đặt chung cho nhiều camera hoặc điều chỉnh từng camera cho phù hợp với yêu cầu tại chỗ.",
  "resources.accessories.title": "Phụ kiện camera",
  "resources.accessories.description": "Xem tài liệu kỹ thuật như hướng dẫn lắp đặt và datasheet cho phụ kiện camera.",
  "resources.discontinued.title": "Sản phẩm đã ngừng",
  "resources.discontinued.description": "Xem tài liệu kỹ thuật và firmware cho các camera và cảm biến đã ngừng sản xuất.",
  "resources.learnMore": "Tìm hiểu thêm",
  "breadcrumb.solutions": "Giải pháp",
  "toc.title": "Mục lục",
  "sidebar.interestedTitle": "Quan tâm đến giải pháp này?",
  "sidebar.interestedDescription": "Trao đổi với VIVOO về phạm vi giám sát, cấu hình thiết bị và yêu cầu tích hợp của dự án.",
  "sidebar.requestQuote": "YÊU CẦU BÁO GIÁ",
  "service.tag": "Dịch vụ",
  "service.interestedTitle": "Bạn quan tâm đến dịch vụ này?",
  "service.interestedDescription": "Gửi yêu cầu về phạm vi công việc, địa điểm và thiết bị để xác định phương án dịch vụ phù hợp.",
  "service.requestQuote": "YÊU CẦU BÁO GIÁ",
  "service.noContent": "Không có nội dung chi tiết cho dịch vụ này.",
  "breadcrumb.services": "Dịch vụ",
  "productGrid.title": "Camera và thiết bị giám sát",
  "productGrid.description": "Danh mục camera AI, thiết bị ghi hình và phụ kiện VIVOO, kèm thông số kỹ thuật phục vụ lựa chọn và thiết kế hệ thống.",
  "cta.ready": "Cần tư vấn triển khai {title}?",
  "cta.auditDescription": "Trao đổi với đội ngũ VIVOO về hiện trạng, yêu cầu kỹ thuật và phương án triển khai cho hệ thống của bạn.",
  "cta.getFreeAudit": "Trao đổi với chuyên gia",
  "cta.contactSales": "Liên hệ bán hàng",
  "cta.learnMore": "TÌM HIỂU THÊM",
  "cta.requestQuote": "YÊU CẦU BÁO GIÁ",
  "cta.downloadGuide": "TẢI HƯỚNG DẪN",
  "solution.noContent": "Không có nội dung chi tiết cho giải pháp này.",
  "faq.title": "Câu hỏi thường gặp về hệ thống camera",
  "faq.q1.question": "Hệ thống camera có thể hỗ trợ giám sát từ xa không?",
  "faq.q1.answer": "Có. Tùy cấu hình và kết nối mạng, người dùng được phân quyền có thể xem camera và sự kiện trên ứng dụng hoặc nền tảng quản lý.",
  "faq.q2.question": "Cần lưu ý gì khi chọn camera cho dự án?",
  "faq.q2.answer": "Cần xác định khu vực quan sát, khoảng cách, điều kiện ánh sáng, độ phân giải, khả năng phân tích và phương án lưu trữ.",
  "faq.q3.question": "Có thể quản lý nhiều camera trên cùng một hệ thống không?",
  "faq.q3.answer": "Có. Nền tảng quản lý tập trung có thể gom thiết bị và sự kiện từ nhiều khu vực về một giao diện, tùy khả năng tích hợp của hệ thống.",
  "product.relatedProductsTitle": "Khám phá các sản phẩm liên quan",
  "product.relatedProductsDescription": "Xem thêm camera và thiết bị tương thích để hoàn thiện cấu hình giám sát theo nhu cầu của dự án.",
  "appDownload.title": "Kết nối ứng dụng",
  "appDownload.appStore": "Tải xuống trên",
  "appDownload.googlePlay": "TẢI VỀ TRÊN"
};
